import { $host, handleError, handleResponse } from './index';

export const homeworkQuestions = async (homework_id) => {
  if (!homework_id) throw new Error('Не указан homework_id');
  try {
    const res = await $host.get(
      `/api/students/homeworks/${homework_id}/questions`,
      { withCredentials: true });
    return handleResponse(res);
  } catch (error) {
    handleError(error);
  }
};

export const homeworkQuestionsWithAnswers = async (homework_id) => {
  if (!homework_id) throw new Error('Не указан homework_id');
  try {
    const res = await $host.get(
      `/api/students/homeworks/${homework_id}/users/questions`,
      { withCredentials: true }
    );
    return handleResponse(res);
  } catch (error) {
    handleError(error);
  }
};

export const homeworkQuestionByID = async (question_id) => {
  if (!question_id) throw new Error('Не указан question_id');
  try {
    const res = await $host.get(`/api/students/questions/${question_id}`, { withCredentials: true });
    return handleResponse(res);
  } catch (error) {
    handleError(error);
  }
};

export const getHomeWorkByHomeWorkId = async (homework_id) => {
  if (!homework_id) throw new Error('Не указан homework_id');

  try {
    const res = await $host.get(`/api/teachers/homeworks/${homework_id}`, { withCredentials: true });
    return handleResponse(res);
  } catch (error) {
    handleError(error);
  }
};

export const homeworkAnswerPost = async (question_id, formData) => {
  if (!question_id) throw new Error('Не указан question_id');
  try {
    const res = await $host.post(
      `/api/students/questions/${question_id}/answer`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return handleResponse(res);
  } catch (error) {
    handleError(error);
  }
};
